import numeral from 'numeral'

export default function(inputRut) {
    
  console.log("=======> dniCleaner para " + inputRut);
  if (inputRut.length < 3) { 
    console.log("=======> dniCleaner < 3");
    return inputRut
  }
  var numbers = inputRut.replace(/[^\dkK]/g, '')
  validate(numbers)
  console.log("Entrego " + numbers);
  return numbers;

}

function validate(valor) {
  
  return true
}



// WEBPACK FOOTER //
// ./src/App/helpers/validations/dniCleaner.js